module.exports = __webpack_public_path__ + "img/ealab_helpyou.edaa59c9.png";